export class FormBase<T> {
    value: T;
    key: string;
    label: string;
    required: boolean;
    order: number;
    controlType: string;
    startAt: Date;
    disabled: boolean;
    step: number;
    type: any;
    options: any;
  
    constructor(options: {
        value?: T,
        key?: string,
        label?: string,
        required?: boolean,
        order?: number,
        controlType?: string,
        startAt?: Date,
        disabled?: boolean,
        step?: number,
        type?: any,
        options?: any
      } = {}) {
      this.value = options.value;
      this.key = options.key || '';
      this.label = options.label || '';
      this.required = !!options.required;
      this.order = options.order === undefined ? 1 : options.order;
      this.controlType = options.controlType || '';
      this.startAt = options.startAt || null;
      this.disabled = options.disabled || false;
      this.step = options.step || 1;
      this.type = options.type || 'text';
      this.options = options.options || [];
    }
  }